import cn from 'classnames'
import * as React from 'react'
import { useSetContentElement } from './context'
import styles from './Sheet.module.css'
import { useIsContentScrollable } from './useIsContentScrollable'

export function Content({ children, className }: React.PropsWithChildren<{ className?: string }>) {
  const contentRef = React.useRef<HTMLDivElement | null>(null)
  useSetContentElement(contentRef)
  const isScrollable = useIsContentScrollable()

  return (
    <div
      ref={contentRef}
      className={cn(styles.content, className)}
      tabIndex={isScrollable ? 0 : undefined}
    >
      {children}
    </div>
  )
}
